import React, {useState} from "react";
import Button from "../../components/Button.jsx";
import {useTranslation} from "react-i18next";
import DeleteProjectYesNo from "./DeleteProjectYesNo.jsx";

export default function DeleteProjectContent({project}) {
    let {t} = useTranslation();

    let [deletePressed, setDeletePressed] = useState(false);

    return (
        <>
            <DeleteProjectYesNo
                visible={deletePressed}
                setVisible={setDeletePressed}
                project={project}
            />

            <div className={'flex justify-between p-2 gap-3 items-center'}>
                <div>
                    {t('project.to-delete-project-press-button')}
                </div>

                <div>
                    <Button variant="outline-red" onClick={() => setDeletePressed(true)}>
                        {t('project.delete')}
                    </Button>
                </div>

            </div>
        </>
    );

}
